import React from 'react'
import { Mail, Shield, FileText } from 'lucide-react'

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container-max py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-lg font-semibold mb-4">AI 트렌드 뉴스레터</h3>
            <p className="text-gray-400 mb-4">
              글로벌 AI 커뮤니티의 최신 인사이트를
              <br />
              매주 5분 핵심 요약으로 전달합니다.
            </p>
            <div className="flex items-center space-x-2 text-gray-400">
              <Mail className="w-4 h-4" />
              <span>dkim@dkeducation.com</span>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">서비스</h3>
            <ul className="space-y-2 text-gray-400">
              <li>AI 트렌드 분석</li>
              <li>주간 뉴스레터</li>
              <li>실전 AI 툴 가이드</li>
              <li>커뮤니티 인사이트</li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">법적 고지</h3>
            <div className="space-y-2">
              <a 
                href="#" 
                className="flex items-center space-x-2 text-gray-400 hover:text-white transition-colors"
              >
                <FileText className="w-4 h-4" />
                <span>이용약관</span>
              </a>
              <a 
                href="#" 
                className="flex items-center space-x-2 text-gray-400 hover:text-white transition-colors"
              >
                <Shield className="w-4 h-4" />
                <span>개인정보보호</span>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; 2024 주식회사 다캐아애듀캐아숀. All rights reserved.</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
